export default `
    query ($email: String!, $authId: String, $refresh: Boolean, $userKey: String){
        getGoogleAnalyticsProperties(email: $email, authId: $authId, refresh: $refresh, userKey: $userKey){
            accountId
            accountName
            properties{
                propertyId
                propertyName
                profiles{
                    profileId
                    profileName
                }
            }
        }
    }
`